import { Stack, styled } from '@mui/material'

export const StylerContainer = styled(Stack, { name: 'StylerContainer' })({
  flexDirection: 'row',
  height: '42px',
  width: '100%',
})
